import { render } from "./LbrxNumPad.vue?vue&type=template&id=96e41d88"
import script from "./LbrxNumPad.vue?vue&type=script&lang=js"
export * from "./LbrxNumPad.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__